<template>
  <TableTemplate
    v-model="mappedAccounts"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :max="max"
    :enable-sorting="true"    

    :on-row-click="updateAccount"
    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Gebruikersaccounts"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :exportParams="exportEndpointParams"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
        <template #after-title>
          <HeaderButton class="ml-2"
            buttonTypeClass="btn-outline-primary btn-primary-secondary-outline"
            style="padding: 11px 8px"
            @click.native="addAccount"
          >
            Account toevoegen
          </HeaderButton>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <div class="delete-icon" @click="confirmDelete(item)">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen accounts"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import HeaderButton from "src/components/Inputs/HeaderButton.vue"

import table from "src/mixins/table"

export default {
  metaInfo: {
    title: "Gebruikersaccounts",
  },
  components: {
    TableCell,
    TableHeader,
    TableMainSearchField,
    HeaderButton,
    TableActionDropdown,
    FormSelect,
    TableTemplate,
    TableSearchField,
    RefreshBtn,
    EmptyStatePlaceholder,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'accounts',
      
      defaultColumnSizes: {
        status: 120,
        role: 120,
      },
      params: {
        role: null,
        status: null,
        email: "",
        name: "",
        search: "",
      },
      route: "/api/accounts",
    }),
  ],
  methods: {
    addAccount() {
      this.$pushModal({
        modal: "EditAccount",
        toBind: {
          callback: this.freshRefetch,
        },
      })
    },
    updateAccount(account) {
      this.$pushModal({
        modal: "EditAccount",
        toBind: {
          account: this.tableResult.find(item => item.uid === account.uid),
          callback: this.freshRefetch,
        },
      })
    },
    async deleteAccount(uid) {
      await this.$handlePromise(
        this.axios.delete(`/api/accounts/${uid}`)
      )
      this.$success("Account verwijderd!")
      this.freshRefetch()
    },
    getWebsiteList(websites) {
      return websites.length === 1 ? websites[0].domainname : websites.reduce((str, site) => {
        return !str.length ? `, ${site.domainname}` : site.domainname
      }, "")
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.deleteAccount(item.uid),
        {
          title: "Account verwijderen",
          description: `Are you sure you want to delete the <b>${item.name}</b> account?`,
          buttonSave: "Verwijderen",
        }
      )
    },
  },
  computed: {
    
    mappedAccounts() {
      return this.tableResult.map ? this.tableResult.map(item => ({
        ...item,
        websites: (
          item.websites ? this.getWebsiteList(item.websites) : 0
        ),
        role: item.role === "SUPER_ADMIN" ? "Super admin" : item.role,
      })) : this.tableResult
    },
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Naam', 'Email', 'Websites', 'Status', 'Rol']
    },
    websiteColumnVariables() {
      return ['name', 'email', 'websites', 'status', 'role']
    },
    capitalize() {
      return [false, false, false, true, true]
    },
  },
}

</script>
